import { LuX } from 'react-icons/lu'
import SvgIcon from '@mui/material/SvgIcon'
import IconLLM from './IconLLM'
import IconAgent from './IconAgent'
import IconNetwork from './IconNetwork'
import IconEndpoint from './IconEndpoint'
import IconLocation from './IconLocation'

export interface IconNodeProps extends React.SVGProps<SVGSVGElement> {
  type?: GraphNode['type']
  plus?: boolean
  outline?: boolean
  offline?: boolean
  size?: number
  currentColor?: boolean
}

export default function IconNode({ type, size, ...props }: IconNodeProps) {
  if (size) props.width = props.height = size
  switch (type) {
    case 'network':
      return <IconNetwork {...props} />
    case 'node':
      return <IconAgent {...props} />
    case 'llm':
      return <IconLLM {...props} />
    case 'service':
      return <IconEndpoint {...props} />
    case 'location':
      return <IconLocation {...props} />
    case 'account':
      return <IconAgent {...props} />
    default:
      return (
        <SvgIcon
          component={LuX}
          sx={{
            width: size ? `${size / 2}px` : undefined,
            height: size ? `${size / 2}px` : undefined,
            marginX: 1,
            color: props.color,
          }}
        />
      )
  }
}
